// libs
import React from 'react';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

//hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// styles
import { AddToWishlistText, HeartEmpty, HeartFilled, WishlistContainer } from './styles';
import { SpotLoader } from '@nykaa/ui-components/Loader';

interface IWishlist {
  isWishListProduct: boolean;
  handleClick: () => void;
  isUpdating: boolean;
}

const WISHLIST_ICON_SIZE = 16;

function WishlistButton({ isWishListProduct, handleClick, isUpdating = false }: IWishlist) {
  const WISHLIST_BUTTON_TEXT = isWishListProduct ? 'Added to Wishlist' : 'Add to Wishlist';
  const theme: Theme = useTheme();
  const HeartFilledIcon = useStoreIcon(IconName.WISHLIST, 'filled');
  const HeartPlusIcon = useStoreIcon(IconName.HEART_PLUS);

  return (
    <WishlistContainer onClick={handleClick}>
      {isUpdating ? (
        <SpotLoader />
      ) : (
        <>
          {isWishListProduct ? (
            <HeartFilled>
              <HeartFilledIcon color={theme.colors.secondary} size={`${WISHLIST_ICON_SIZE}px`} />
            </HeartFilled>
          ) : (
            <HeartEmpty>
              <HeartPlusIcon color={theme.colors.primary} size={`${WISHLIST_ICON_SIZE}px`} />
            </HeartEmpty>
          )}
          <AddToWishlistText>{WISHLIST_BUTTON_TEXT}</AddToWishlistText>
        </>
      )}
    </WishlistContainer>
  );
}

export default WishlistButton;
